"use client";

import { useEffect, useState } from "react";

/**
 * Tracks whether the tab is currently in the foreground.
 *
 * Browsers pause *video* in a background tab but keep *audio* playing, so a
 * video that has been unmuted will keep talking after the visitor switches
 * away. Callers use this to force-mute while hidden.
 *
 * SSR-safe: starts `true` on the server and first client render, which matches
 * the overwhelmingly common case and means nothing flickers on hydration.
 */
export const usePageVisible = () => {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const sync = () => setVisible(!document.hidden);

		// The tab can already be hidden by the time we mount (e.g. the page was
		// opened in a background tab), so read once before subscribing.
		sync();

		document.addEventListener("visibilitychange", sync);
		return () => document.removeEventListener("visibilitychange", sync);
	}, []);

	return visible;
};
